import { useMemo } from 'react';
import useRecordSubject from './hooks/useRecordSubject';
import useCurrentOwner from './hooks/useCurrentOwner';
import useAuth from './hooks/useAuth';
import RecordTimeline from 'crm-timeline/timelineEmbed/RecordTimeline';
import { useQueryParams } from '../../router/useQueryParams';
import { useRecordPermissions } from '../permissions/RecordPermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineContainer = () => {
  const {
    objectType,
    subjectId
  } = useRecordSubject();
  const {
    currentUserCanCommunicate,
    currentUserCanEdit
  } = useRecordPermissions();
  const currentOwnerId = useCurrentOwner();
  const auth = useAuth();
  const query = useQueryParams();
  const timeline = useMemo(() => {
    const activeTaskId = query.taskId && typeof query.taskId === 'string' ? parseInt(query.taskId, 10) : undefined;
    const eventsProps = {
      activeTaskId,
      auth,
      currentUserCanCommunicate,
      currentUserCanEdit,
      currentOwnerId,
      key: `timeline-tabs-container-${objectType}-${subjectId}`,
      objectType,
      query,
      subjectId,
      taskId: activeTaskId
    };
    return /*#__PURE__*/_jsx(RecordTimeline, Object.assign({}, eventsProps));
  }, [currentUserCanCommunicate, currentUserCanEdit, objectType, query, subjectId, currentOwnerId, auth]);
  return timeline;
};
export default TimelineContainer;